var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerificationIconYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3a5 5 0 00-3.456 8.613C5.606 12.76 3.538 15.166 3.01 18.86a1 1 0 101.98.285C5.5 15.634 8.426 13 12 13c1.875 0 3.217.555 4.195 1.296l1.21-1.592a8.041 8.041 0 00-1.949-1.09A5 5 0 0012 3zM9 8a3 3 0 116 0 3 3 0 01-6 0z",
    fill: "#F9B035"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.677 15.736a1 1 0 10-1.355-1.472l-4.752 4.377-1.893-1.745a1 1 0 00-1.355 1.471l2.232 2.056a1.5 1.5 0 002.033 0l5.09-4.687z",
    fill: "#F9B035"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerificationIconYellow);
export default __webpack_public_path__ + "static/media/verification-icon-yellow.b52c529e81d22d140aba2d09157ebfdf.svg";
export { ForwardRef as ReactComponent };